/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CreateUpdateCertificateDto,
    CreateUpdateCertificateDtoFromJSON,
    CreateUpdateCertificateDtoFromJSONTyped,
    CreateUpdateCertificateDtoToJSON,
    CreateUpdateOrganizationDto,
    CreateUpdateOrganizationDtoFromJSON,
    CreateUpdateOrganizationDtoFromJSONTyped,
    CreateUpdateOrganizationDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateUpdateCertificateWithOrganizationDto
 */
export interface CreateUpdateCertificateWithOrganizationDto {
    /**
     * 
     * @type {CreateUpdateCertificateDto}
     * @memberof CreateUpdateCertificateWithOrganizationDto
     */
    certificate: CreateUpdateCertificateDto;
    /**
     * 
     * @type {CreateUpdateOrganizationDto}
     * @memberof CreateUpdateCertificateWithOrganizationDto
     */
    organization: CreateUpdateOrganizationDto;
}

export function CreateUpdateCertificateWithOrganizationDtoFromJSON(json: any): CreateUpdateCertificateWithOrganizationDto {
    return CreateUpdateCertificateWithOrganizationDtoFromJSONTyped(json, false);
}

export function CreateUpdateCertificateWithOrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateCertificateWithOrganizationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'certificate': CreateUpdateCertificateDtoFromJSON(json['certificate']),
        'organization': CreateUpdateOrganizationDtoFromJSON(json['organization']),
    };
}

export function CreateUpdateCertificateWithOrganizationDtoToJSON(value?: CreateUpdateCertificateWithOrganizationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'certificate': CreateUpdateCertificateDtoToJSON(value.certificate),
        'organization': CreateUpdateOrganizationDtoToJSON(value.organization),
    };
}


